import { Tool } from '@app/shared/utils/enums';
import { PetOwner } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
/**
 * Action dispatched to create the consultation.
 * It actually uses an effect to gather information and create the consultation in the consultation store
 */
export const createAllowanceConsultation = createAction('[Allowance] Create Consultation', props<{ owner?: PetOwner; tool?: Tool }>());
